<template>
  <div :class="keyboardClass"></div>
</template>

<script>
import Keyboard from 'simple-keyboard'
import 'simple-keyboard/build/css/index.css'

export default {
  name: 'SimpleKeyboard',
  props: {
    keyboardClass: {
      default: 'simple-keyboard',
      type: String
    },
    input: {
      type: Number | String
    },
    theme: String
  },
  data: () => ({
    keyboard: null
  }),
  mounted() {
    this.keyboard = new Keyboard({
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      theme: this.theme,
      layout: {
        default: ['1 2 3', '4 5 6', '7 8 9', '{shift} 0 .', '{bksp}'],
        shift: ['! / #', '$ % ^', '& * (', '{shift} ) +', '{bksp}']
      }
    })
  },
  methods: {
    onChange(input) {
      this.$emit('onChange', input)
    },
    onKeyPress(button) {
      this.$emit('onKeyPress', button)

      /**
       * If you want to handle the shift and caps lock buttons
       */
      if (button === '{shift}' || button === '{lock}') this.handleShift()
      if (button === '{bksp}') this.handleBksp()
    },
    handleShift() {
      let currentLayout = this.keyboard.options.layoutName
      let shiftToggle = currentLayout === 'default' ? 'shift' : 'default'

      this.keyboard.setOptions({
        layoutName: shiftToggle
      })
    },
    handleBksp() {
      if (this.input != null) {
        this.keyboard.setInput(parseFloat(this.input.toString().slice(0, -1)))
      }
    }
  },
  watch: {
    input(input) {
      this.keyboard.setInput(input)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.simple-keyboard {
  max-width: 850px;
}
/*
  Theme: numeric
*/
.numeric-theme {
  max-width: 320px;
  margin: 0 auto;
}

.numeric-theme + .simple-keyboard-preview {
  max-width: 320px;
}

.simple-keyboard.hg-theme-default.numeric-theme
  .hg-button.hg-standardBtn.hg-button-at {
  max-width: none;
}
.hg-theme-default.hg-layout-numeric .hg-button {
  font-size: 15px;
  font-weight: 700;
}
</style>
